<body class="hold-transition login-page" style="background-color: #f4f6f9; font-family: 'Roboto', sans-serif;">
  <div class="container d-flex justify-content-center align-items-center" style="min-height: 100vh;">
    <div class="login-box shadow-lg rounded" style="width: 400px; background: white; padding: 20px; border-radius: 10px;">
      <!-- Logo -->
      <div class="login-logo text-center mb-4">
        <h2><b style="font-size: 42px; color: #007bff;">Prid Portal</b></h2>
      </div>

      <!-- Card -->
      <div class="card">
        <div class="card-body">
          <!-- Page Message -->
          <p class="login-box-msg" style="font-size: 18px;">Enter your registered email address</p>
          
          <!-- Loader -->
          <div *ngIf="loader == true" style="text-align: center;">
            <app-loader></app-loader>
          </div>
          
          <!-- Forgot Password Form -->
          <form>
            <!-- Email -->
            <div class="form-group mb-3">
              <label for="username" class="form-label" style="font-size: 18px;">Email</label>
              <div class="input-group">
                <input id="username" type="email" class="form-control form-control-lg" #username placeholder="Enter your registered email">
                <div class="input-group-append">
                  <div class="input-group-text">
                    <span class="fas fa-envelope"></span>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Submit Button -->
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-primary btn-lg mt-3" (click)="Submit(username.value)">Submit</button>
            </div>
          </form>

          <!-- Links -->
          <div class="mt-3 text-center">
            <a routerLink="/login" class="text-decoration-none">Back to Login</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
